
import React from 'react';
import { NavBarPortfolioSelector } from '@/components/navbar/NavBarPortfolioSelector';

interface PortfolioDesktopSelectorProps {
  selectedPortfolio: string;
  portfolioOptions: Array<{id: string; title: string; role: string | null}>;
  onPortfolioChange: (value: string) => void;
}

const PortfolioDesktopSelector = ({
  selectedPortfolio,
  portfolioOptions,
  onPortfolioChange
}: PortfolioDesktopSelectorProps) => {
  return (
    <div className="mb-6">
      <div className="flex items-center">
        <div className="font-medium text-sm text-gray-500 mr-3">Current Portfolio:</div>
        <NavBarPortfolioSelector
          selectedPortfolio={selectedPortfolio}
          portfolioOptions={portfolioOptions}
          onPortfolioChange={onPortfolioChange}
        />
      </div>
    </div>
  );
};

export default PortfolioDesktopSelector;
